import { Image } from "primereact/image";

/**
 * The file name the receiver picked. The stored name is "<timestamp>-<8 hex>-<name>" (the timestamp and code only keep two photos
 * with the same name apart), so that prefix is left out.
 */
export const getReceiverImageName = (url: string, index: number): string => {
    let name: string;
    try {
        name = decodeURIComponent(new URL(url).pathname.split("/").pop() ?? "");
    } catch {
        name = url.split("?")[0].split("/").pop() ?? "";
    }
    name = name.replace(/^\d{10,}-[0-9a-f]{8}-/i, "");
    return name || `Image ${index + 1}`;
};

/** The photos the receiver uploaded (verify form / return after receipt): thumbnails that open full size, with the file name below. */
export default function ReceiverImageThumbs({ urls }: { urls?: string[] }) {
    if (!urls || urls.length === 0) {
        return null;
    }

    return (
        <div className="d-flex flex-wrap gap-3">
            {urls.map((url, index) => {
                const name = getReceiverImageName(url, index);
                return (
                    <div key={`${url}-${index}`} className="text-center" style={{ width: "100px" }}>
                        <Image src={url} zoomSrc={url} preview width="100" height="75" alt={name} className="file-card-image" />
                        <div className="text-truncate small" title={name} data-testid="receiver-image-name">{name}</div>
                    </div>
                );
            })}
        </div>
    );
}
